import { Dispatch, SetStateAction, useEffect } from "react";
import EducationFlow from "../EducationFlow";
import useEducationFlow from "../useEducationFlow";
import { useFourDPSteps } from "./fourDPSteps";
import FourDPPages from "../../Quiz/4dpQuiz/FourDPPages";
import { SourcePage } from "@/services/Analytics/EventTypes";
import useLocalStorage from "@/hooks/useLocalStorage";

function FourDPEducation({
  isStandAlone,
  setPage,
  finishedEducation,
  setFinishedEducation,
  closeOnBack,
}: {
  isStandAlone: boolean;
  setPage?: Dispatch<SetStateAction<number>>;
  finishedEducation?: boolean;
  setFinishedEducation?: (finishedEducation: boolean) => void;
  closeOnBack: boolean;
}) {
  const steps = useFourDPSteps(0, isStandAlone);
  const { setValue: setHasSeenFlow } = useLocalStorage("hasSeenFourDPEducationFlow");

  useEffect(() => {
    setHasSeenFlow(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { activeStep, handleNext, handleBack, handleSkip, bodyRef } = useEducationFlow({
    steps,
    isStandAlone,
    setPage,
    finishedEducation,
    setFinishedEducation,
    closeOnBack,
    analyticsEventName: "4dp_education",
    analyticsSourcePage: SourcePage.fourdp_education,
    closePortalId: "fourdp",
    nextPage: FourDPPages.quiz,
    localStorageKey: "hasSeenFourDPEducationFlow",
  });

  // Re-create steps with the current activeStep for graph animations
  const currentSteps = useFourDPSteps(activeStep, isStandAlone);

  return (
    <EducationFlow
      steps={currentSteps}
      activeStep={activeStep}
      handleNext={handleNext}
      handleBack={handleBack}
      handleSkip={handleSkip}
      bodyRef={bodyRef}
      isStandAlone={isStandAlone}
    />
  );
}

export default FourDPEducation;
